<template>
  <div class="responsive-table" :class="{ 'table-expanded': tableExpanded }">
    <div class="toolbar">
      <button class="btn btn-default pull-right" type="button" style="max-width: 50px;"
      v-if="!tableExpanded" @click="expandTable()">
        <span class="fa fa-fw fa-expand"></span>
      </button>
      <button class="btn btn-default pull-right" type="button" style="max-width: 50px;"
      v-if="tableExpanded" @click="closeTable()">
        <span class="fa fa-fw fa-compress"></span>
      </button>
    </div>
    <h4>{{ table.title }} <span class="label label-info" v-if="table.count">{{ table.count }}</span></h4>
    <div class="billing-table">
      <div class="row billing-headings">
        <template v-for="column in table.columns">
          <div :class="'col-xs-' + column.span">
            <strong>{{ column.title }}</strong>
          </div>
        </template>
      </div>
      <div class="billing-header"></div>
      <template v-for="(i, row) in table.rows">
        <div class="row billing-item" :class="{ 'hover': i % 2 == 0 }">
          <template v-for="column in table.columns">
            <div :class="['col-xs-' + column.span, { 'no-gutter': column.noGutter }]">
              <template v-if="column.type === 'link'">
                <a v-if="row[column.name].link" v-link="{ path: row[column.name].link }" :target="row[column.name].target ? row[column.name].target : '_self'">
                  {{ row[column.name].label }}
                </a>
                <span v-else>
                  {{ row[column.name].label }}
                </span>
              </template>
              <template v-if="column.type === 'date'">
                {{ row[column.name].date | date_format row[column.name].timezone }}
              </template>
              <template v-if="column.type === 'shortDate'">
                {{ row[column.name] | short_date_format }}
              </template>
              <template v-if="column.type === 'text'">
                {{ row[column.name] }}
              </template>
              <template v-if="column.type === 'currency'">
                {{ row[column.name] | currency_round_neg }}
              </template>
              <template v-if="column.type === 'button'">
                <a v-if="row[column.name].link" :class="`btn-${row[column.name].buttonType}`" class="btn btn-small interactive-cursor" v-link="{ path: row[column.name].link }">
                  <span v-if="row[column.name].icon" :class="`fa ${row[column.name].icon} fa-fw`"></span> {{ row[column.name].buttonText }}
                </a>
                <button v-if="row[column.name].functionName" :class="`btn-${row[column.name].buttonType}`" class="btn btn-small" @click="$dispatch(row[column.name].functionName, row[column.name].functionParams)">
                  <span v-if="row[column.name].icon" :class="`fa ${row[column.name].icon} fa-fw`"></span> {{ row[column.name].buttonText }}
                </button>
                <span v-if="row[column.name].labelText" :class="`label-${row[column.name].labelType}`" class="label">
                  {{ row[column.name].labelText }}
                </span>
              </template>
              <template v-if="column.type === 'label' && row[column.name].labelText">
                <span :class="`label-${row[column.name].labelType}`" class="label">
                  {{ row[column.name].labelText }}
                </span>
              </template>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResponsiveTable',
  props: {
    table: {
      type: Object,
      default () {
        return {
          title: 'Table',
          count: 0,
          columns: [
            { title: 'ID', span: 4, name: 'id' },
            { title: 'Data', span: 4, name: 'data' },
            { title: 'Status', span: 4, name: 'status' }
          ],
          rows: [
            { id: 'reservation', name: 'Data', status: '--' }
          ]
        }
      }
    }
  },
  data () {
    return {
      tableExpanded: false
    }
  },
  route: {
    data () {
    }
  },
  ready () {
  },
  methods: {
    expandTable () {
      this.tableExpanded = true
    },
    closeTable () {
      this.tableExpanded = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// ResponsiveTable.vue?1c3d262e